document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.sa-products').forEach(initShopAllSection);
  document.querySelectorAll('[data-sa-card]').forEach(initShopAllCard);
});

/* ---------- Toolbar: filters + sorting (native Shopify filters via section rendering) ---------- */

function initShopAllSection(root) {
  var sectionId = root.dataset.sectionId;
  var baseUrl = root.dataset.sectionUrl;
  var filterToggle = root.querySelector('[data-sa-filter-toggle]');
  var filtersPanel = root.querySelector('[data-sa-filters-panel]');
  var filterClose = root.querySelector('[data-sa-filters-close]');
  var filterForm = root.querySelector('[data-sa-filter-form]');
  var sortSelect = root.querySelector('[data-sa-sort-select]');
  var sortHidden = root.querySelector('[data-sa-sort-hidden]');

  if (filterToggle && filtersPanel) {
    filterToggle.addEventListener('click', function () {
      filtersPanel.setAttribute('data-open', 'true');
      filterToggle.setAttribute('aria-expanded', 'true');
    });
  }

  if (filterClose && filtersPanel) {
    filterClose.addEventListener('click', function () {
      filtersPanel.setAttribute('data-open', 'false');
      filterToggle && filterToggle.setAttribute('aria-expanded', 'false');
    });
  }

  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      if (sortHidden && filterForm) {
        sortHidden.value = sortSelect.value;
        submitFilters();
      } else {
        fetchAndReplace(baseUrl + '?sort_by=' + encodeURIComponent(sortSelect.value) + '&section_id=' + sectionId);
      }
    });
  }

  if (filterForm) {
    filterForm.querySelectorAll('[data-sa-filter-input]').forEach(function (input) {
      input.addEventListener('change', submitFilters);
    });
  }

  var debounceTimer;
  function submitFilters() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      var params = new URLSearchParams(new FormData(filterForm));
      fetchAndReplace(baseUrl + '?' + params.toString() + '&section_id=' + sectionId);
    }, 150);
  }

  function fetchAndReplace(url) {
    root.setAttribute('aria-busy', 'true');
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newRoot = doc.getElementById('ShopAllSection-' + sectionId);
        if (newRoot) {
          root.innerHTML = newRoot.innerHTML;
          initShopAllSection(root);
          root.querySelectorAll('[data-sa-card]').forEach(initShopAllCard);
          window.history.replaceState({}, '', url.split('&section_id=')[0]);
        }
      })
      .catch(function () {
        window.location.href = url.split('&section_id=')[0];
      })
      .finally(function () {
        root.removeAttribute('aria-busy');
      });
  }

  root.querySelectorAll('[data-sa-load-more]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      fetch(link.getAttribute('href') + '&section_id=' + sectionId)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('[data-sa-grid]');
          var newPagination = doc.querySelector('.sa-pagination');
          var currentGrid = root.querySelector('[data-sa-grid]');
          var currentPagination = root.querySelector('.sa-pagination');
          if (newGrid && currentGrid) {
            Array.from(newGrid.children).forEach(function (item) {
              currentGrid.appendChild(item);
              item.querySelectorAll('[data-sa-card]').forEach(initShopAllCard);
            });
          }
          if (currentPagination) {
            currentPagination.replaceWith(newPagination || document.createElement('div'));
          }
        });
    });
  });
}

/* ---------- Product card: variant selection + AJAX add to cart ---------- */

function initShopAllCard(card) {
  if (card.dataset.saInitialized === 'true') return;
  card.dataset.saInitialized = 'true';

  var dataScript = card.querySelector('[data-sa-product-json]');
  var productData = null;
  try {
    productData = JSON.parse(dataScript.textContent);
  } catch (e) {
    productData = null;
  }

  var confirmEl = card.querySelector('[data-sa-confirm]');
  var errorEl = card.querySelector('[data-sa-error]');

  /* Simple add (no variants) */
  var simpleBtn = card.querySelector('[data-sa-add-simple]');
  if (simpleBtn) {
    simpleBtn.addEventListener('click', function () {
      addToCart(simpleBtn.dataset.variantId, simpleBtn);
    });
  }

  /* Toggle options panel */
  var toggleBtn = card.querySelector('[data-sa-toggle-options]');
  var optionsPanel = card.querySelector('[data-sa-options-panel]');
  if (toggleBtn && optionsPanel) {
    toggleBtn.addEventListener('click', function () {
      var isHidden = optionsPanel.hasAttribute('hidden');
      if (isHidden) {
        optionsPanel.removeAttribute('hidden');
        toggleBtn.textContent = 'Hide Options';
      } else {
        optionsPanel.setAttribute('hidden', '');
        toggleBtn.textContent = 'Select Options';
      }
    });
  }

  /* Option selection + availability */
  var optionGroups = card.querySelectorAll('[data-sa-option-group]');
  var confirmBtn = card.querySelector('[data-sa-add-variant]');
  var hintEl = card.querySelector('[data-sa-option-hint]');
  var selections = [];

  if (productData) {
    optionGroups.forEach(function () { selections.push(null); });

    optionGroups.forEach(function (group) {
      var index = parseInt(group.dataset.optionIndex, 10);
      group.querySelectorAll('[data-sa-option-value]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          group.querySelectorAll('[data-sa-option-value]').forEach(function (b) { b.classList.remove('is-selected'); });
          btn.classList.add('is-selected');
          selections[index] = btn.dataset.value;
          refreshAvailability();
        });
      });
    });

    refreshAvailability();
  }

  function matchesPartial(variantOptions, testSelections) {
    for (var i = 0; i < testSelections.length; i++) {
      if (testSelections[i] !== null && testSelections[i] !== variantOptions[i]) return false;
    }
    return true;
  }

  function refreshAvailability() {
    optionGroups.forEach(function (group) {
      var index = parseInt(group.dataset.optionIndex, 10);
      group.querySelectorAll('[data-sa-option-value]').forEach(function (btn) {
        var candidate = selections.slice();
        candidate[index] = btn.dataset.value;
        var possible = productData.variants.some(function (v) {
          return matchesPartial(v.options, candidate) && v.available;
        });
        btn.classList.toggle('is-unavailable', !possible);
      });
    });

    var allSelected = selections.every(function (s) { return s !== null; });

    if (!allSelected) {
      if (confirmBtn) confirmBtn.disabled = true;
      if (hintEl) hintEl.textContent = 'Select all options';
      return;
    }

    var matchedVariant = productData.variants.find(function (v) {
      return matchesPartial(v.options, selections) && v.options.every(function (opt, i) { return opt === selections[i]; });
    });

    if (matchedVariant && matchedVariant.available) {
      if (confirmBtn) {
        confirmBtn.disabled = false;
        confirmBtn.dataset.variantId = matchedVariant.id;
      }
      if (hintEl) hintEl.textContent = '';
    } else {
      if (confirmBtn) confirmBtn.disabled = true;
      if (hintEl) hintEl.textContent = matchedVariant ? 'This combination is sold out' : '';
    }
  }

  if (confirmBtn) {
    confirmBtn.addEventListener('click', function () {
      if (confirmBtn.disabled) return;
      addToCart(confirmBtn.dataset.variantId, confirmBtn);
    });
  }

  /* ---------- AJAX add to cart ---------- */
  function addToCart(variantId, triggerButton) {
    if (!variantId) return;
    hideMessage(errorEl);
    var originalText = triggerButton.textContent;
    triggerButton.disabled = true;
    triggerButton.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (data) {
            throw new Error((data && data.description) || 'Could not add to cart');
          });
        }
        return response.json();
      })
      .then(function () {
        return fetch('/cart.js');
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
        showMessage(confirmEl);
        triggerButton.textContent = originalText;
        triggerButton.disabled = false;
      })
      .catch(function (err) {
        if (errorEl) {
          errorEl.textContent = err.message || 'Something went wrong. Please try again.';
        }
        showMessage(errorEl);
        triggerButton.textContent = originalText;
        triggerButton.disabled = false;
      });
  }

  function showMessage(el) {
    if (!el) return;
    el.removeAttribute('hidden');
    clearTimeout(el._saTimer);
    el._saTimer = setTimeout(function () {
      el.setAttribute('hidden', '');
    }, 2500);
  }

  function hideMessage(el) {
    if (!el) return;
    el.setAttribute('hidden', '');
    clearTimeout(el._saTimer);
  }
}

/* ---------- Cart count (best-effort integration with existing theme cart icon) ---------- */

function updateCartCount(count) {
  document.querySelectorAll('[data-cart-count]').forEach(function (el) {
    el.textContent = count;
  });
  document.querySelectorAll('.cart-count-bubble').forEach(function (el) {
    var span = el.querySelector('span[aria-hidden="true"]');
    if (span) {
      span.textContent = count;
    } else {
      el.textContent = count;
    }
    el.style.display = count > 0 ? '' : 'none';
  });
}
